var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.58301,
    y: 1,
    width: 12.6153,
    height: 18.2099,
    rx: 2,
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2832 13.6997H11.0423",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9746 13.5896H14.7171",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50244 16.5093H13.8395",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69237 3.13896H2.33492C2.1439 3.13896 1.95229 3.09584 1.76183 3.1106C1.4463 3.13504 1.07035 3.35002 1.00477 4.07139V16.4673C0.970146 16.7962 1.10932 17.4662 1.90678 17.6481C1.99905 17.6692 2.0944 17.6739 2.18904 17.6739H3.69237",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3076 3.2249H17.6651C17.8561 3.2249 18.0477 3.18178 18.2382 3.19653C18.5537 3.22098 18.9296 3.43596 18.9952 4.15733V16.5532C19.0299 16.8822 18.8907 17.5522 18.0932 17.7341C18.001 17.7551 17.9056 17.7599 17.811 17.7599H16.3076",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3537 5.80143L12.1466 6.54822H8.18945L8.39661 5.80143H12.3537ZM10.4386 10.4214L8.31206 7.91945L8.30783 7.29079H9.31825C9.58037 7.29079 9.79598 7.24438 9.96509 7.15156C10.137 7.05593 10.2653 6.92795 10.3498 6.76762C10.4344 6.60448 10.4766 6.42306 10.4766 6.22335C10.4766 6.00677 10.4372 5.8155 10.3583 5.64954C10.2794 5.48359 10.1539 5.3542 9.982 5.26138C9.81008 5.16856 9.58319 5.12215 9.30134 5.12215H8.19368L8.42198 4.27832H9.30134C9.80021 4.27832 10.2145 4.35286 10.5443 4.50194C10.874 4.65101 11.1207 4.8676 11.2841 5.15168C11.4504 5.43577 11.5336 5.77893 11.5336 6.18116C11.5336 6.53275 11.473 6.84356 11.3518 7.11359C11.2306 7.3808 11.0347 7.59739 10.7641 7.76334C10.4936 7.92648 10.1342 8.02774 9.68606 8.06712L11.6308 10.3666V10.4214H10.4386ZM12.358 4.27832L12.1466 5.02511H8.91239L9.11955 4.27832H12.358Z",
    fill: "#2E77D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/Insurance.edf9d631e17d1672f6d961c1dc2776d8.svg";
export { ForwardRef as ReactComponent };